import { loadTurnstile } from './loader'
import { resolveContainerElement } from './container'
import { getRuntimeState } from './state'
import type {
  BrowserWindow,
  TurnstileRenderContainer,
  TurnstileRenderOptions,
  TurnstileRuntimeOptions,
} from './types'

/**
 * Renders a Turnstile widget into a connected container and tracks ownership.
 */
export const renderTurnstile = async (
  container: TurnstileRenderContainer,
  options: TurnstileRenderOptions,
  runtimeOptions?: TurnstileRuntimeOptions,
): Promise<string> => {
  const api = await loadTurnstile(runtimeOptions)
  const target = resolveContainerElement(container)
  if (!target) {
    throw new Error('Turnstile target container not found')
  }
  if (!target.isConnected) {
    throw new Error('Turnstile target container is disconnected from the document')
  }

  const browserWindow = window as BrowserWindow
  const state = getRuntimeState(browserWindow)
  const previousWidgetId = state.containerWidgets.get(target)
  if (previousWidgetId) {
    if (state.activeWidgetIds.has(previousWidgetId)) {
      api.remove?.(previousWidgetId)
      state.activeWidgetIds.delete(previousWidgetId)
    }
    state.containerWidgets.delete(target)
  }

  target.innerHTML = ''
  const widgetId = api.render(target, options)
  state.containerWidgets.set(target, widgetId)
  state.activeWidgetIds.add(widgetId)
  return widgetId
}
